import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/components/ui/sonner";
import { api } from "@/lib/api";
import { getLocalDateInputValue } from "@/lib/date";
import { emptyRatings, fruits } from "@/data/fruits";

const calculateAverage = (ratings) => (Object.values(ratings).reduce((sum, value) => sum + value, 0) / fruits.length).toFixed(2);
const buildReflectionPayload = ({ monthlySummary, notes, period, promptResponse, ratings, reflectionDate }) => ({
  period,
  reflection_date: reflectionDate,
  ratings,
  notes,
  prompt_response: promptResponse,
  monthly_summary: period === "monthly" ? monthlySummary : "",
});

export const useReflectionForm = () => {
  const [period, setPeriod] = useState("daily");
  const [reflectionDate, setReflectionDate] = useState(getLocalDateInputValue());
  const [ratings, setRatings] = useState(emptyRatings);
  const [notes, setNotes] = useState("");
  const [promptResponse, setPromptResponse] = useState("");
  const [monthlySummary, setMonthlySummary] = useState("");
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const average = calculateAverage(ratings);

  const setRating = (fruit, value) => setRatings((current) => ({ ...current, [fruit]: value }));

  const submitReflection = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await api.post("/reflections", buildReflectionPayload({ monthlySummary, notes, period, promptResponse, ratings, reflectionDate }));
      toast.success("Reflection saved.");
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Reflection could not be saved.");
    } finally {
      setSaving(false);
    }
  };

  return {
    average,
    notes,
    monthlySummary,
    period,
    promptResponse,
    ratings,
    reflectionDate,
    saving,
    setNotes,
    setMonthlySummary,
    setPeriod,
    setPromptResponse,
    setRating,
    setReflectionDate,
    submitReflection,
  };
};